import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const RewardConfigPanel = ({ rewards, onUpdate }) => {
  const [editingId, setEditingId] = useState(null);
  const [editForm, setEditForm] = useState({});

  const startEdit = (reward) => {
    setEditingId(reward?.id);
    setEditForm({
      title: reward?.title,
      description: reward?.description,
      pointCost: reward?.pointCost,
      benefitValue: reward?.benefitValue,
      isActive: reward?.isActive
    });
  };

  const cancelEdit = () => {
    setEditingId(null);
    setEditForm({});
  };

  const saveEdit = async (rewardId) => {
    await onUpdate(rewardId, editForm);
    setEditingId(null);
    setEditForm({});
  };

  return (
    <div className="bg-card rounded-lg shadow-elevation-2">
      <div className="p-24 border-b border-border">
        <h3 className="text-xl font-heading font-semibold text-secondary">
          Reward Configuration
        </h3>
        <p className="text-sm text-muted-foreground mt-4">
          Manage reward options, point costs, and availability
        </p>
      </div>

      <div className="p-24 space-y-16">
        {rewards?.map((reward) => (
          <div key={reward?.id} className="border border-border rounded-lg p-20">
            {editingId === reward?.id ? (
              <div className="space-y-16">
                <div>
                  <label className="block text-sm font-medium text-foreground mb-8">Title</label>
                  <input
                    type="text"
                    value={editForm?.title}
                    onChange={(e) => setEditForm({ ...editForm, title: e?.target?.value })}
                    className="w-full px-16 py-10 border border-border rounded-lg bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-primary/50"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-foreground mb-8">Description</label>
                  <textarea
                    value={editForm?.description}
                    onChange={(e) => setEditForm({ ...editForm, description: e?.target?.value })}
                    rows={3}
                    className="w-full px-16 py-10 border border-border rounded-lg bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-primary/50"
                  />
                </div>
                <div className="grid grid-cols-2 gap-16">
                  <div>
                    <label className="block text-sm font-medium text-foreground mb-8">Point Cost</label>
                    <input
                      type="number"
                      value={editForm?.pointCost}
                      onChange={(e) => setEditForm({ ...editForm, pointCost: parseInt(e?.target?.value) })}
                      className="w-full px-16 py-10 border border-border rounded-lg bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-primary/50"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-foreground mb-8">Benefit Value</label>
                    <input
                      type="text"
                      value={editForm?.benefitValue}
                      onChange={(e) => setEditForm({ ...editForm, benefitValue: e?.target?.value })}
                      className="w-full px-16 py-10 border border-border rounded-lg bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-primary/50"
                    />
                  </div>
                </div>
                <div className="flex items-center space-x-12">
                  <input
                    type="checkbox"
                    id={`active-${reward?.id}`}
                    checked={editForm?.isActive}
                    onChange={(e) => setEditForm({ ...editForm, isActive: e?.target?.checked })}
                    className="w-16 h-16 text-primary border-border rounded focus:ring-2 focus:ring-primary/50"
                  />
                  <label htmlFor={`active-${reward?.id}`} className="text-sm text-foreground">
                    Active (visible to users)
                  </label>
                </div>
                <div className="flex space-x-12 pt-12">
                  <button
                    onClick={() => saveEdit(reward?.id)}
                    className="flex-1 bg-primary text-white px-16 py-10 rounded-lg font-medium hover:bg-primary/90 transition-smooth"
                  >
                    Save Changes
                  </button>
                  <button
                    onClick={cancelEdit}
                    className="flex-1 bg-muted text-foreground px-16 py-10 rounded-lg font-medium hover:bg-muted/80 transition-smooth"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            ) : (
              <div>
                <div className="flex items-start justify-between mb-12">
                  <div className="flex-1">
                    <div className="flex items-center space-x-12 mb-8">
                      <h4 className="text-lg font-semibold text-foreground">{reward?.title}</h4>
                      {reward?.isActive ? (
                        <span className="bg-success/10 text-success text-xs font-medium px-8 py-2 rounded-full">
                          Active
                        </span>
                      ) : (
                        <span className="bg-muted text-muted-foreground text-xs font-medium px-8 py-2 rounded-full">
                          Inactive
                        </span>
                      )}
                    </div>
                    <p className="text-sm text-muted-foreground mb-12">{reward?.description}</p>
                    <div className="flex items-center space-x-20">
                      <div className="flex items-center space-x-8">
                        <Icon name="Coins" size={16} color="var(--color-primary)" />
                        <span className="text-sm font-medium text-primary">{reward?.pointCost} points</span>
                      </div>
                      <div className="flex items-center space-x-8">
                        <Icon name="Gift" size={16} color="var(--color-accent)" />
                        <span className="text-sm text-foreground">{reward?.benefitValue}</span>
                      </div>
                    </div>
                  </div>
                  <button
                    onClick={() => startEdit(reward)}
                    className="p-10 bg-primary/10 text-primary rounded-lg hover:bg-primary/20 transition-smooth"
                  >
                    <Icon name="Edit" size={18} />
                  </button>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default RewardConfigPanel;